<template>
    <section class="tile h-100">
        <div class="container h-100 mw-100 border-2" :class="isSelected ? 'selected-tile' : ''">
            <div class="row bg-white">
                <div class="col-12 bg-header-tile" :style="'background-image: url('+ offer.backgroundImage +');'">
                    <div class="row">
                        <!--/* BANNIERE + TIMER */-->
                        <div v-if="offer.banner" class="col-12">
                            <div class="tag-timer">
                                <div class="row align-items-center">
                                    <!--/* BANNER */-->
                                    <div class="col-auto p-0">
                                        <div class="ob1-tag ob1-tag-primary">
                                            <span>{{ offer.banner }}</span>
                                        </div>
                                    </div>
                                    <!--/* TIMER */-->
                                    <div v-if="offer.timerEndDateInMilliseconds" class="col-auto">
                                        <timer
                                            :end-date-in-milliseconds="offer.timerEndDateInMilliseconds"
                                            :color="offer.countDownColor ? offer.countDownColor : 'text-dark'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <div class="tag-timer" />
                        </div>

                        <!--/* TEXTUELS A GAUCHE */-->
                        <div class="col-7 pe-0 pt-1">
                            <!--/* NOM DE L'OFFRE */-->
                            <div>
                                <div v-if="offer.hideShortLabel" class="title-align">
                                    <div class="h4 pb-0 mb-1">
                                        <span class="visually-hidden">{{ offer.name }}</span>
                                    </div>
                                </div>
                                <div v-else class="title-align">
                                    <h2
                                        class="h4 pb-0 mb-1"
                                        :class="offer.shortLabelColor ? offer.shortLabelColor : ''"
                                        v-html="offerHtmlName"
                                    />
                                </div>
                            </div>

                            <!--/* PRIX */-->
                            <div>
                                <p class="small fw-bold mb-0 pb-0">
                                    {{ offer.priceConnectedTitle }}
                                </p>
                                <Price
                                    class="price-align"
                                    :price="offer.price.price"
                                    :initial-price="offer.price.initialPrice"
                                    :price-details="offer.price.priceDetails ? offer.price.priceDetails : undefined"
                                    :show-from="offer.price.showFrom"
                                    :show-by-month="offer.price.showByMonth"
                                    :show-promo-duration="offer.price.showPromoDuration"
                                    :show-end-of-promotion-price="offer.price.showEndOfPromotionPrice"
                                    :duration="offer.price.duration"
                                    :is-cents-format="false"
                                    :is-compact="offer.price.compact"
                                    :custom="priceCustomClasses"
                                />
                            </div>
                        </div>

                        <!--/* VISUEL A DROITE */-->
                        <div class="col-5 px-0 pt-1 text-center">
                            <div v-if="offer.visualUrl">
                                <img
                                    width="100%"
                                    style="max-width: 130px;"
                                    :alt="offer.visualAlt"
                                    :src="offer.visualUrl"
                                >
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="mobileprice-odrmention-align">
                                <!--/* PRIX CLIENT MOBILE */-->
                                <div v-if="offer.mobileDiscountedPrice" class="bg-greige p-1 mb-0">
                                    <p class="small m-0 p-0">
                                        <strong>{{ offer.mobileDiscountedPriceTitle }}</strong>
                                    </p>
                                    <p class="small m-0 p-0">
                                        <span>{{ offer.mobileDiscountedPrice.price }}/mois</span>
                                        <span v-if="offer.mobileDiscountedPrice.duration > 0">pendant {{ offer.mobileDiscountedPrice.duration }}&nbsp;mois puis <strong>{{ offer.mobileDiscountedPrice.initialPrice }}/mois</strong></span>
                                    </p>
                                </div>
                                <!--/* PERMANENT ODR MENTION */-->
                                <div v-if="offer.permanentOdrMentionBlock" class="bg-greige p-1 mb-0">
                                    <p class="small m-0 p-0" v-html="offer.permanentOdrMentionBlock.odrTitle" />
                                    <p class="small m-0 p-0" v-html="offer.permanentOdrMentionBlock.odrDescription" />
                                </div>
                            </div>
                        </div>

                        <!--/* LIEN FICHE DETAIL OFFRE */-->
                        <div class="col-12">
                            <div class="detail-link-align">
                                <a
                                    v-if="showDetailPage && detailPageUrl && showDetailPageBtnLabel"
                                    :id="'discover-offer-link-'+ offerTileIndex"
                                    :href="detailPageUrl"
                                    class="ob1-link-arrow"
                                    :data-oevent-action="offer.showOfferDetailPageBtnTms.action"
                                    :data-oevent-category="offer.showOfferDetailPageBtnTms.category"
                                    :data-oevent-label="offer.showOfferDetailPageBtnTms.label"
                                >
                                    {{ showDetailPageBtnLabel }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 pb-2">
                    <!--/* CTA */-->
                    <div class="pt-1 text-center">
                        <div v-if="offer.genericButtonCta">
                            <generic-button-cta
                                :dto-from-object="offer.genericButtonCta"
                                :css-classes="'btn-primary w-100 mw-100'"
                            />
                        </div>
                    </div>

                    <!--/* CTA Comparateur (Réassurance fibre) */-->
                    <div v-if="comparatorCta" class="pt-1 text-center">
                        <generic-button-cta
                            :dto-from-object="comparatorCta"
                            :css-classes="'btn-secondary w-100 mw-100'"
                        />
                    </div>
                    <div v-if="!offer.genericButtonCta && offer.selectButton">
                        <div v-if="isSelected" class="internet-selection h-100">
                            <span class="mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100">
                                <span class="icon icon-tick-circle" style="font-size: 1.5rem" aria-hidden="true" />
                                <span class="lead fw-bold ms-1">{{ buttonLabel }}</span>
                            </span>
                        </div>
                        <div v-else class="internet-selection">
                            <button
                                class="px-1 px-lg-2 btn btn-secondary w-100"
                                type="button"
                                :data-oevent-category="offer.selectButtonTms.category"
                                :data-oevent-action="offer.selectButtonTms.action"
                                :data-oevent-label="offer.selectButtonTms.label"
                                @click="onSelectOffer()"
                            >
                                {{ buttonLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!--/* ATTRIBUTES */-->
            <div class="row bg-white">
                <div
                    class="offer-edito-content col-12"
                    :data-oevent-category="offer.popinTmsDTO.category"
                    :data-oevent-label="offer.popinTmsDTO.label"
                >
                    <div
                        v-for="(attribute, index) in offer.attributes"
                        :key="index"
                    >
                        <div v-if="attribute.hasTopSeparator" class="col-12">
                            <hr class="my-0">
                        </div>
                        <div class="d-flex mb-1">
                            <div v-if="attribute.image" class="offer-tile-attribute-image me-1">
                                <span
                                    class="icon lead text-primary"
                                    aria-hidden="true"
                                    :class="attribute.image"
                                />
                            </div>
                            <div>
                                <span
                                    :class="['font-size-14 media-body-description-'+index]"
                                    v-html="attribute.description"
                                />
                                <strong
                                    v-if="attribute.tag"
                                    class="ob1-tag ob1-tag-small ob1-tag-specific"
                                    v-html="attribute.tag"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--/* VISUAL ATTRIBUTES */-->
            <div>
                <div v-for="(visualClaim) in offer.claims" :key="visualClaim.id" class="row">
                    <div class="col-12 py-1 visual-claim-bg">
                        <div class="d-flex">
                            <div class="pe-1">
                                <span
                                    class="icon h4 mb-0"
                                    aria-hidden="true"
                                    :class="offer.visualClaimsIcon"
                                />
                            </div>
                            <div>
                                <div v-for="(attribute) in visualClaim.attributes" :key="attribute.id">
                                    <p
                                        v-if="attribute.title"
                                        class="fw-bold py-0 mb-0"
                                        v-html="attribute.title"
                                    />
                                    <p
                                        v-if="attribute.textHtml"
                                        class="py-0 mb-0"
                                        v-html="attribute.textHtml"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="visualClaim.visuals" class="col-12 px-0 visual-claim-border bg-white">
                        <div class="text-center">
                            <div class="row justify-content-center px-1 pt-1">
                                <div
                                    v-for="(visual) in visualClaim.visuals"
                                    :key="visual.id"
                                    class="col-4 px-1 pb-1"
                                >
                                    <img
                                        loading="lazy"
                                        :src="visual.url"
                                        :alt="visual.alt"
                                        class="visual-claim-img"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import Price from "../../../../../common/components/ob1/Price.vue";

export default {
    name: "NewInternetOfferTile",
    components: {
        Price,
        GenericButtonCta
    },
    props: {
        offer: {type: Object, required: true},
        comparatorCta: {type: Object, required: false},
        offerTileIndex: {type: Number, required: true},
        showMobileClientOffers: {type: Boolean, default: false},
        showDetailPage: {type: Boolean, default: false},
        showDetailPageBtnLabel: {type: String, default: "Découvrir cette offre"},
        isSelected: {type: Boolean, default: false}
    },
    computed: {
        detailPageUrl() {
            if (this.showDetailPage) {
                return this.offer.detailPageUrl;
            }
            return undefined
        },
        offerHtmlName() {
            const offerName = this.offer.name.trim();
            return (offerName.startsWith("Livebox ")) ? offerName.replace(" Fibre", "<br>Fibre") : offerName;
        },
        priceCustomClasses() {
            if (this.showMobileClientOffers && this.offer.crossDiscountInfo) {
                return 'h3 text-primary price-icon icon ob1-price-compact ' + this.offer.crossDiscountInfo.bannerIcon;
            } else {
                return 'h3 text-primary ob1-price-compact';
            }
        },
        showAuthenticateButton() {
            return this.showMobileClientOffers && this.offer.authenticateDTO;
        },
        buttonLabel() {
            if (this.isSelected) {
                return this.offer.selectedButtonLabel
            } else return this.offer.selectButtonLabel;
        }
    },
    methods: {
        onSelectOffer() {
            this.$emit('select-offer', this.offer.seoId);
        },
        toggleAttributes() {
            this.$emit('toggle-collapsible-attributes');
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.bg-header-tile {
    background-repeat: no-repeat;
    background-size: 100% auto;
}

.border-2 {
    border: px-to-rem(2) solid $gray-lighter;
}

.border-top-bottom-2 {
    border-top: px-to-rem(2) solid $gray-lighter;
    border-bottom: px-to-rem(2) solid $gray-lighter;
}

.visual-claim-img {
    max-width: 100%;
    max-height: 36px;
}

.visual-claim-bg {
    background-color: #ffcd0b;
}

.visual-claim-border {
    border-style: solid;
    border-width: 0 5px 0 5px;
    border-color: #ffcd0b;
}

.selected-tile {
    border: 0.0625rem solid $brand-orange;
    box-shadow: 0.125rem 0.125rem $brand-orange;
}

.ob1-tag.ob1-tag-specific {
    color: #fff;
    background-color: #000;
}

.offer-tile-attribute-image {
    min-width: 16px;
    min-height: 16px;
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        min-width: 18px;
        min-height: 18px;
    }
}
</style>
